interface HTMLElementEvent<T extends HTMLElement> extends Event {
  target: T
}

class appTop {
  constructor(public $: any) {
    this.$ = $
  }

  aloneFunc() {
    const _that = this.$
    const emergency_btn = _that('.emergency_btn')
    const emergency_info = _that('.emergency_info')
    emergency_btn.on('click', function(
      event: HTMLElementEvent<HTMLInputElement>
    ) {
      const toggleElememnt = event.target.firstElementChild!.classList
      if (toggleElememnt.contains('toggle')) {
        toggleElememnt.remove('toggle')
        emergency_info.stop().slideUp()
      } else {
        toggleElememnt.add('toggle')
        emergency_info.stop().slideDown()
      }
    })
  }
}
export default appTop
